import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import faqLeft from '../assets/webp/faqLeft.webp';
import faqRight from '../assets/webp/faqRight.webp';
// import { faqs } from "../constants/homePageConstant";

export default function FaqSect({faq}) {
  const [openIndex, setOpenIndex] = useState(0);


  return (
    <div className="grid grid-cols-1 lgs:grid-cols-5 gap-10 lg:gap-12">
      <div className="lgs:col-span-3 space-y-4">
        <h2 className="text-xl md:text-2xl lg:text-4xl  font-bold text-[#101828] tracking-tight">Frequently asked questions</h2>
        <p className="text-[#667085] text-sm md:text-base lg:text-lg  mt-2">Everything you need to know about the product and billing.</p>
        {faq.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div key={idx} className="rounded-xl bg-white ring-1 ring-black/5 shadow-sm">
              <button
                type="button"
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? -1 : idx)}
              >
                <span className="text-base md:text-lg lgs:text-base xl:text-xl font-bold text-[#1D6076]">{item.q}</span>
                <span className="h-6 w-6 grid place-items-center rounded-full border-2 font-[900] border-[#1D6076] text-[#1D6076]">
                  {isOpen ? <FiMinus /> : <FiPlus />}
                </span>
              </button>
              <div
                className={`px-5 pb-4 text-gray-600 text-sm leading-7 transition-[grid-template-rows] duration-300 ease-out grid ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  }`}
              >
                <div className="overflow-hidden">
                  <p className="text-[#667085] font-[400] text-xs md:text-sm lgs:text-xs xl:text-base">{item.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* Images (Right, narrower) */}
      <div className="hidden lgs:col-span-2 lgs:grid lgs:grid-cols-2 lgs:gap-2">
        {[faqLeft, faqRight].map((imgSrc, idx) => (
          <div key={idx} className="rounded-2xl">
            <img
              src={imgSrc}
              alt={idx === 0 ? "Frequently asked questions left visual" : "Frequently asked questions right visual"}
              className="block w-full h-[420px] object-cover rounded-2xl"
              loading="lazy"
            />
          </div>
        ))}
      </div>

    </div>

  );
}
